export default [
  { value: "Agriculture", label: "Agriculture" },
  { value: "Air", label: "Air" },
  { value: "Biology", label: "Biology" },
  { value: "Boundaries and Base Data", label: "Boundaries and Base Data" },
  { value: "Chemicals", label: "Chemicals" },
  { value: "Cleanup", label: "Cleanup" },
  { value: "Climate", label: "Climate" },
  { value: "Climate Change", label: "Climate Change" },
  { value: "Compliance", label: "Compliance" },
  { value: "Conservation", label: "Conservation" },
  { value: "Contaminant", label: "Contaminant" },
  { value: "Disaster", label: "Disaster" },
  { value: "Drinking Water", label: "Drinking Water" },
  { value: "Ecological", label: "Ecological" },
  { value: "Ecology", label: "Ecology" },
  { value: "Ecosystem", label: "Ecosystem" },
  { value: "Emergency", label: "Emergency" },
  { value: "Emergency Response", label: "Emergency Response" },
  { value: "Energy", label: "Energy" },
  { value: "Enforcement", label: "Enforcement" },
  { value: "Environment", label: "Environment" },
  { value: "Estuary", label: "Estuary" },
  { value: "Exposure", label: "Exposure" },
  { value: "Facilities", label: "Facilities" },
  { value: "Grants", label: "Grants" },
  { value: "Ground Water", label: "Ground Water" },
  { value: "Hazards", label: "Hazards" },
  { value: "Health", label: "Health" },
  { value: "Human", label: "Human" },
  { value: "Impact", label: "Impact" },
  { value: "Indicator", label: "Indicator" },
  { value: "Indoor Air", label: "Indoor Air" },
  { value: "Inspections", label: "Inspections" },
  { value: "Land", label: "Land" },
  { value: "Management", label: "Management" },
  { value: "Marine", label: "Marine" },
  { value: "Modeling", label: "Modeling" },
  { value: "Monitoring", label: "Monitoring" },
  { value: "Natural Resources", label: "Natural Resources" },
  { value: "Permits", label: "Permits" },
  { value: "Pesticides", label: "Pesticides" },
  { value: "Quality", label: "Quality" },
  { value: "Radiation", label: "Radiation" },
  { value: "Recreation", label: "Recreation" },
  { value: "Regulated Facilities", label: "Regulated Facilities" },
  { value: "Regulatory", label: "Regulatory" },
  { value: "Remediation", label: "Remediation" },
  { value: "Response", label: "Response" },
  { value: "Risk", label: "Risk" },
  { value: "Sites", label: "Sites" },
  { value: "Spills", label: "Spills" },
  { value: "Surface Water", label: "Surface Water" },
  { value: "Sustainability", label: "Sustainability" },
  { value: "Toxics", label: "Toxics" },
  { value: "Transportation", label: "Transportation" },
  { value: "Waste", label: "Waste" },
  { value: "Water", label: "Water" }
];
